export default class Team {
    public id!: number;
    public name!: string;

    public static fromData(data: any): Team {
        const team = new Team();
        team.id = data.id;
        team.name = data.name;

        return team;
    }
}
